<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  }),
  mounted() {
    // const meta = document.getElementsByTagName('meta')['viewport']
    // meta.setAttribute('name', 'viewport')
    // meta.setAttribute('content', 'width=960')
    // eslint-disable-next-line no-console
    // if (process.env.NODE_ENV === 'development') console.log(this.$vuetify.breakpoint.name)
    // let body = document.createElement('body')
    // body.style.width = '700px'
    // const width = document.documentElement.clientWidth
    // let meta = document.createElement('meta')
    // let w = screen.width
    // if (w > 640) {
    //   meta.setAttribute('name', 'viewport')
    //   meta.setAttribute('content', 'width=960')
    // } else {
    //   meta.setAttribute('name', 'viewport')
    //   meta.setAttribute('content', `width=device-width initial-scale=1`)
    // }
  }
}
</script>
